module.exports = __webpack_public_path__ + "img/13.15625006.jpg";